import { createContext, useEffect, useState } from "react";

export const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {

    const [isDarkTheme, setIsDarkTheme] = useState(true);

    useEffect(() => {
        const savedTheme = localStorage.getItem('theme') || "lightTheme";
        document.body.className = savedTheme;
        setIsDarkTheme(savedTheme !== 'darkTheme');
    }, []);

    return (
        <ThemeContext.Provider value={{ isDarkTheme, setIsDarkTheme }}>
            {children}
        </ThemeContext.Provider>
    )
}
